import * as actions from "./ipsecVendorsGetActions";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";
import { IpsecVendorsGetState } from "./types";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS: {
  [key: string]: (
    state: IpsecVendorsGetState,
    action: any
  ) => IpsecVendorsGetState;
} = {
  [actions.IPSEC_VENDORS_GET_REQUEST]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [actions.IPSEC_VENDORS_GET_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    error: null,
    ipsecVendors: action.data?.ipsecVendors ?? action.data,
    lastFetch: Date.now(),
  }),
  [actions.IPSEC_VENDORS_GET_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
    lastFetch: Date.now(), // Track attempt time to prevent infinite retry loops
  }),
  [actions.IPSEC_VENDORS_CLEAR]: () => initialState,
  [CURRENT_CHILD_ORGANIZATION_SET]: () => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState: IpsecVendorsGetState = {
  loading: false,
  error: null,
  ipsecVendors: null,
  lastFetch: null,
};

export default function ipsecVendorsGetReducer(
  state: IpsecVendorsGetState = initialState,
  action: any
): IpsecVendorsGetState {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
